var map = {
	"./AAVE.svg": 3462,
	"./ADA.svg": 9675,
	"./ALICE.svg": 7557,
	"./ARB.svg": 7361,
	"./BNB.svg": 6888,
	"./BTC.svg": 1501,
	"./BTCB.svg": 4667,
	"./BUSD.svg": 6309,
	"./Cake.svg": 8119,
	"./DAI.svg": 1791,
	"./DERI.svg": 1291,
	"./DOGE.svg": 7465,
	"./DOT.svg": 561,
	"./ETH.svg": 5314,
	"./LINK.svg": 2975,
	"./LTC.svg": 906,
	"./LUNA.svg": 5747,
	"./LUSD.svg": 4692,
	"./MANTA.svg": 68,
	"./MATIC.svg": 3388,
	"./SXP.svg": 6654,
	"./TRX.svg": 1598,
	"./TUSD.svg": 8027,
	"./USDB.svg": 8459,
	"./USDC.svg": 2951,
	"./USDT.svg": 815,
	"./UST.svg": 8901,
	"./WBNB.svg": 4782,
	"./WBTC.svg": 5218,
	"./WETH.svg": 3205,
	"./WSTETH.svg": 7283,
	"./XRP.svg": 7928,
	"./XVS.svg": 7254,
	"./amusdc.svg": 7367,
	"./arrow-down.svg": 8688,
	"./arrow-left copy.svg": 8167,
	"./arrow-left.svg": 7209,
	"./arrow-right copy.svg": 8831,
	"./arrow-right.svg": 8900,
	"./arrow-up.svg": 5362,
	"./close-modal-icon copy.svg": 7049,
	"./close-modal-icon.svg": 642,
	"./deri-fi.png": 5497,
	"./deri-lite.svg": 8527,
	"./logo.svg": 5522,
	"./menu.svg": 2898,
	"./work-order.svg": 9910
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;